import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);
  const faqs = [{
    question: 'What is an EICR and why do I need one?',
    answer: 'An Electrical Installation Condition Report (EICR) is an assessment of the safety of the existing electrical installations within a property. It identifies any damage, deterioration, defects, or dangerous conditions. Landlords in England are legally required to have an EICR conducted every 5 years. Homeowners are recommended to have one every 10 years, or when buying/selling a property.'
  }, {
    question: 'How long does an EICR inspection take?',
    answer: 'The duration of an EICR inspection depends on the size of your property and the complexity of the electrical installation. For an average 3-bedroom house, the inspection typically takes 2-4 hours. Larger properties or those with more complex electrical systems may take longer.'
  }, {
    question: 'What happens if my property fails the EICR?',
    answer: 'If your property fails the EICR, the report will highlight the issues that need to be addressed. These will be classified as C1 (danger present), C2 (potentially dangerous), or C3 (improvement recommended). For C1 and C2 issues, remedial work must be carried out to make the installation safe. We can provide quotes for any necessary remedial work.'
  }, {
    question: 'How often do I need to renew my EICR certificate?',
    answer: "For rental properties in England, landlords must renew their EICR certificate every 5 years. For homeowners, it's recommended to have an EICR conducted every 10 years, or when buying/selling a property. Commercial properties typically require an EICR every 5 years, but this can vary depending on the type of business."
  }, {
    question: 'Do I need to be present during the inspection?',
    answer: "It's beneficial but not always necessary for you to be present during the inspection. As long as our electrician has access to all areas of the property including the consumer unit (fuse box), they can conduct the inspection. However, being present allows you to discuss any specific concerns directly with the electrician."
  }, {
    question: 'Will my power be turned off during the inspection?',
    answer: 'Yes, the power will need to be turned off for parts of the inspection to safely test the electrical installation. This usually occurs for short periods during the inspection. We recommend backing up any computers and notifying anyone in the property before the inspection.'
  }];
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };
  return <section id="faq" className="py-16" data-id="element-118">
      <div className="container mx-auto px-4" data-id="element-119">
        <div className="text-center mb-12" data-id="element-120">
          <h2 className="text-3xl font-bold text-gray-800 mb-4" data-id="element-121">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-122">
            Find answers to common questions about EICR certificates and our
            services.
          </p>
        </div>
        <div className="max-w-3xl mx-auto" data-id="element-123">
          {faqs.map((faq, index) => <div key={index} className="border-b border-gray-200 last:border-b-0" data-id="element-124">
              <button className="flex justify-between items-center w-full text-left py-4 px-1" onClick={() => toggleFAQ(index)} data-id="element-125">
                <h3 className="text-lg font-semibold text-gray-800" data-id="element-126">
                  {faq.question}
                </h3>
                {openIndex === index ? <ChevronUpIcon className="w-5 h-5 text-blue-600 flex-shrink-0" data-id="element-127" /> : <ChevronDownIcon className="w-5 h-5 text-blue-600 flex-shrink-0" data-id="element-128" />}
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96 pb-4' : 'max-h-0'}`} data-id="element-129">
                <p className="text-gray-600" data-id="element-130">{faq.answer}</p>
              </div>
            </div>)}
        </div>
        <div className="mt-10 text-center" data-id="element-131">
          <p className="text-gray-600 mb-4" data-id="element-132">
            Still have questions about our EICR services?
          </p>
          <a href="#contact" className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded transition-colors" data-id="element-133">
            Contact Us
          </a>
        </div>
      </div>
    </section>;
};
export default FAQ;